module.exports = __webpack_public_path__ + "img/factory_iron.424a7aeb.jpg";